export default __webpack_public_path__ + "static/media/mobile_05.b7bd3109.png";